// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"textformat-italic"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 4H17.5M7 20H15.5M13.4063 4.5L10.5938 19.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextformatItalicIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textformat-italic',
    ref,
    icon: element,
  },
));

TextformatItalicIcon.displayName = 'TextformatItalicIcon';

export default TextformatItalicIcon;
